import { useState, useEffect, useCallback, useRef } from "react";
import { twitterApi } from "../services/twitterApi";

const REFRESH_MS = 15 * 60 * 1000; // 15 minutes (rate limit compliance)

export function useTwitter() {
  const [data, setData]               = useState(null);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const fetch = useCallback(async () => {
    try {
      const overview = await twitterApi.overview();
      if (!mountedRef.current) return;
      setData(overview);
      setLastUpdated(new Date());
      setError(null);
    } catch (err) {
      if (mountedRef.current) setError(err.message);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
    const t = setInterval(fetch, REFRESH_MS);
    return () => clearInterval(t);
  }, [fetch]);

  const byPub = {};
  if (data?.publications) {
    data.publications.forEach(p => { byPub[p.pub] = p; });
  }

  return { data, byPub, loading, error, lastUpdated, refresh: fetch };
}
